import React from 'react';

const Charitra = () => {
  return (
    <section className="story-section charitra-page page-content">
      <div className="slokam-card" aria-label="శ్రీరామ శ్లోకము">
        <figure className="centered-image-frame">
          <img src="/pattabhisriseetharamaswamy.png" alt="పట్టాభిషేక శ్రీ సీతారామచంద్రస్వామివారి దివ్య చిత్రము" />
        </figure>
        <p>|| శ్రీ రామ రామ రామేతి రమే రామే మనోరమే ||</p>
        <p>|| సహస్రనామ తత్తుల్యం రామ నామ వరాననే ||</p>
      </div>

      <article className="story-content">
        <p className="mantra-highlight">శ్రీ రామాయ నమః</p>
        <p className="tab-copy">
          సాధారణంగా ప్రతి గ్రామంలో ఒక గ్రామదేవత రక్షణగా, ఒక కులదైవం ఆశీస్సుగా ఉండటం మన సంప్రదాయం.
 అయితే, ఈ లోకంలో ఎందరో దైవాలు వెలసినప్పటికీ, "ఊరు" అనే మాటకు "రామాలయం" అనే పదం ఒక పర్యాయపదంగా మారిపోయింది. అది కేవలం ఒక సంకల్పం మాత్రమే కాదు, ఆ మర్యాదా పురుషోత్తముడు మన జీవనశైలితో కలిసిపోయిన తీరు.
          శ్రీరాముడు కేవలం ఆరాధించే దైవం మాత్రమే కాదు, అనుసరించాల్సిన ఒక జీవన మార్గం. అందుకే ఏ ఊరైనా, ఏ వాడైనా సరే... ఆ రామయ్య గుడి లేని ఊరు, రామనామం వినపడని గడప ఉండదు. శివకేశవుల అభేదానికి నిదర్శనంగా, ప్రతి పల్లె గుండెలోనూ పట్టాభిరాముడు కొలువై ఉంటాడు.
          మిగతా ఆలయాలు ఆయా సంప్రదాయాలకు ప్రతీకలైతే, రామాలయం మాత్రం భారతీయ జీవన సంస్కృతికి, ధర్మానికి ఒక నిలువుటద్దం. అందుకే "రామాయ రామభద్రాయ" అనే మంత్రం ప్రతి పల్లెలోనూ లోకకల్యాణార్థం మారుమోగుతూనే ఉంటుంది. అది ఒక దివ్య వైభవం, ప్రతి గ్రామానికి దక్కిన ఒక ఆధ్యాత్మిక వరం.</p>

        <h3 className="sub-section-title">సంకల్పం: దైవప్రేరణతో అంకురార్పణ</h3>
        <div className="side-by-side-content">
          <div className="text-content">
            <p className="tab-copy">
              మన వామకుంట్ల గ్రామంలో ఈ దైవ సంకల్పానికి, రామాలయ నిర్మాణానికి దైవానుజ్ఞతో జన్మించిన సత్యనిరతి కలిగిన వ్యక్తి శ్రీ గోదా హనుమంతు గారు.
            </p>
            <p className="tab-copy">
              ఆయన ఒక సాధారణ రైతు కుటుంబంలో జన్మించినా, ఆయన హృదయం నిండా అసాధారణమైన రామభక్తి నింపుకున్నారు. తన స్వయంకృషితో, తీక్షణమైన భక్తితో, ఒక మహాత్తరమైన బలమైన దైవ సంకల్పంతో రామాలయ నిర్మాణానికి నాంది పలికారు. "రామకార్యం" అంటే రాముడికి మనం చేసే ఉపకారం కాదు, అది మన జన్మను తరింపజేసుకునే అవకాశం. నాడు సేతుబంధన సమయంలో ఉడుత ఇసుక రేణువులను మోసి రాముని కార్యంలో పాలుపంచుకున్నట్టే, తాను కూడా స్వామి సేవలో భాగస్వామి కావాలని తపించి, అశేష భక్తజనుల సహకారంతో ఈ ఆలయ నిర్మాణాన్ని ప్రారంభించారు.
            </p>
          </div>
          <figure className="side-image-frame">
            <img src="/godaganumanthgaru.jpeg" alt="శ్రీ గోదా హనుమంతు గారు" />
          </figure>
        </div>

        <h3 className="sub-section-title">దార్శనికత: గుడితోపాటు బడి</h3>
        <p className="tab-copy">
          ఈ మహనీయుడి సేవ కేవలం ఆలయానికే పరిమితం కాలేదు. ఆయన ముందుచూపు అమోఘం. ఆయన బుద్ధి కుశలతను గమనిస్తే... "ఊరంటే గుడి-బడి ఉండాలి" అనే సత్సంకల్పంతో, ఆలయానికి భూమిని కేటాయించడమే కాకుండా, ప్రభుత్వ పాఠశాల నిర్మాణానికి కూడా సరిపడా భూమిని దానం చేశారు. సుమారు 50 ఎకరాలకు పైగా భూమిని సేకరించి, భవిష్యత్తులో ఆలయ అర్చకత్వానికి, నిత్య కైంకర్యాలకు ఎటువంటి లోటు రాకుండా ఒక దృఢమైన వ్యవస్థను స్థాపించారు. ఆయన వేసిన పునాది నేడు మన గ్రామానికి ఒక రక్షణ కవచంలా నిలిచింది.
        </p>

        <h3 className="sub-section-title">పునర్నిర్మాణం: మనందరి భాగ్యం</h3>
        <p className="tab-copy">
          నాడు ఆయన అంకురార్పణ చేసిన ఆ దివ్య ధామం, నేడు పునర్నిర్మాణం జరుపుకుంటోంది. ఇది మనందరికీ దక్కిన ఒక అరుదైన సదవకాశం. ఒక గ్రామంలో రామాలయ పునర్నిర్మాణంలో పాలుపంచుకునే భాగ్యం అందరికీ దక్కదు. అది మన పూర్వజన్మ సుకృతం.
        </p>

        <blockquote className="story-quote">
          రామాయ రామభద్రాయ రామచంద్రాయ వేధసే |<br/>
          రఘునాథాయ నాథాయ సీతాయాః పతయే నమః ||
        </blockquote>

        <p className="tab-copy">
          ఈ మహాత్కార్యంలో మనమందరం భాగస్వాములవుదాం. త్రికరణ శుద్ధిగా, మన శక్తి వంచన లేకుండా ఆ స్వామి కార్యానికి చేయీ చేయీ కలిపి, వామకుంట్ల రామాల్యాన్ని భక్తి వైభవంతో పునర్నిర్మిద్దాం.
        </p>
      </article>
    </section>
  );
};

export default Charitra;
